(function(ns) {

	/// @var string
	var assetsModified = "20180726";

	/// @param string id
	/// @param object options
	/// @return Vue.Component
	function createComponentWithTemplate(id, options) {
		options.template = getTemplate(id);
		return Vue.component(id, options);
	}

	/// @return string
	function getTemplate(id) {
		var E = document.getElementById("vue-" + id);
		return E ? E.innerHTML : "";
	}

	/// @return string
	function antiCache() {
		return "?v=" + assetsModified;
	}

	/// @param object data
	/// @param object rules
	/// @param object &errors
	/// @return integer エラー数
	function validate(data, rules, errors) {
		var errorCount = 0;
		Object.keys(rules).forEach(function(field) {
			var hasError = rules[field].some(function(ruleDesc) {
				var args = ruleDesc.split(/:/g);
				var ruleName = args.shift();
				var fn = ns.validator[ruleName];
				if (typeof fn !== "function") {
					console.warn("Validation rule \"" + ruleName + "\" does not exists.");
					return false;
				}
				args.push(data[field] || null);
				var success = fn.apply(null, args);
				if (success) {
					// Vue.set() で変更を検出可能なプロパティを追加
					Vue.set(errors, field, null);
					if (typeof success !== "boolean") {
						data[field] = success; // 戻り値が true, false 以外の場合は値の正規化として扱い、もとの値を書き換える
					}
					return false;
				} else {
					// Vue.set() で変更を検出可能なプロパティを追加
					Vue.set(errors, field, ruleDesc);
					return true;
				}
			});
			if (hasError) {
				errorCount++;
			}
		});
		return errorCount;
	}

	ns.util = {
		component: createComponentWithTemplate,
		antiCache: antiCache,
		validate: validate,
		handleErrorOffset: function() {
			return $("#globalnav").height() + 20;
		},
	};

})(UE);
